import { Shield, Award, Users, Clock } from "lucide-react";

const features = [
  {
    icon: Shield,
    title: "Garanzia di Qualità",
    description: "Utilizziamo solo materiali certificati e di prima qualità per ogni intervento."
  },
  {
    icon: Award,
    title: "Personale Qualificato",
    description: "Tecnici certificati e costantemente aggiornati sulle ultime tecnologie."
  },
  {
    icon: Users,
    title: "Assistenza Clienti",
    description: "Supporto dedicato prima, durante e dopo ogni intervento."
  },
  {
    icon: Clock,
    title: "Puntualità",
    description: "Rispettiamo sempre i tempi concordati per ogni lavoro."
  }
];

const AboutSection = () => {
  return (
    <section id="chi-siamo" className="py-24 bg-[#f8f9fa]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#5abb3d] font-semibold tracking-[0.2em] uppercase text-sm">
              Chi Siamo
            </span>
            <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-[#29383d] mt-4 tracking-tight">
              Scavone Service
              <br />
              <span className="text-[#5abb3d]">E&J</span>
            </h2>
            <p className="text-[#394b52] mt-6 leading-relaxed text-lg">
              Da oltre 15 anni siamo il punto di riferimento per le soluzioni energetiche e impiantistiche 
              in tutto il Veneto. La nostra missione è garantire il massimo comfort abitativo attraverso 
              servizi professionali e tecnologie all'avanguardia.
            </p>
            <p className="text-[#394b52] mt-4 leading-relaxed">
              Dalla climatizzazione all'installazione di impianti fotovoltaici, dalla manutenzione delle caldaie 
              alla ristrutturazione dei tetti, il nostro team di esperti è sempre pronto a offrire soluzioni 
              personalizzate per ogni esigenza.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-10">
              <div className="text-center p-4 bg-white rounded-xl border border-[#e5e7eb]">
                <span className="block text-3xl font-bold text-[#5abb3d]">15+</span>
                <span className="text-[#394b52] text-sm">Anni Esperienza</span>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-[#e5e7eb]">
                <span className="block text-3xl font-bold text-[#5abb3d]">500+</span>
                <span className="text-[#394b52] text-sm">Clienti Serviti</span>
              </div>
              <div className="text-center p-4 bg-white rounded-xl border border-[#e5e7eb]">
                <span className="block text-3xl font-bold text-[#5abb3d]">100%</span>
                <span className="text-[#394b52] text-sm">Soddisfatti</span>
              </div>
            </div>
          </div>

          {/* Right Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={feature.title}
                className={`p-6 bg-white rounded-2xl border border-[#e5e7eb] hover:shadow-lg hover:-translate-y-1 transition-all duration-300 opacity-0 animate-fade-in-up stagger-${index + 1}`}
                data-testid={`about-feature-${index}`}
              >
                <div className="w-12 h-12 bg-[#5abb3d]/10 rounded-xl flex items-center justify-center mb-4">
                  <feature.icon className="w-6 h-6 text-[#5abb3d]" />
                </div>
                <h3 className="font-outfit text-lg font-semibold text-[#29383d] mb-2">
                  {feature.title}
                </h3>
                <p className="text-[#394b52] text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
